import React, { useMemo } from 'react';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { convertiUtsToDate } from '../GrapheXT/GrapheXT';

const TableauMinMaxDate = ({
  configuration,
  donnees,
  viewobj_json_content,
  switchAfficherModifierIntervalle,
  dimensionWidth,
  dimensionHeight,
  donneesGraphe,
}) => {
  const tableData = useMemo(() => {
    if (!configuration || !donnees) {
      return { data: [], layout: {} };
    }

    const layout = {
      font: { size: 14 },
      title: {
        text: configuration.title + '<br>' + configuration.subtitle,
        font: { color: '#3c3935' },
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        x: 0,
        y: -0.0,
      },
      ...(viewobj_json_content?.layout || {}),
    };

    let headers_values = [];
    let headers_unit = [];
    let sensors_names = [];
    let noms_responsables = [];
    let dates_max = [];
    let values_max = [];
    let dates_min = [];
    let values_min = [];

    for (let curve of donnees) {
      let index_sensor_name = sensors_names.indexOf(curve.sensor_name);
      let index_prefix =
        curve.prefix === '' ? -1 : headers_values.indexOf(curve.prefix);
      let index_position_in_sensor =
        curve.position_in_sensor === ''
          ? -1
          : headers_values.indexOf(curve.position_in_sensor);

      if (index_sensor_name < 0) {
        sensors_names.push(curve.sensor_name);
        noms_responsables.push(curve.name);

        for (let ind_col = 0; ind_col < headers_values.length; ind_col++) {
          values_max[ind_col] = values_max[ind_col] || [];
          values_max[ind_col].push(null);
          values_min[ind_col] = values_min[ind_col] || [];
          values_min[ind_col].push(null);
        }
      }

      index_sensor_name =
        index_sensor_name < 0 ? sensors_names.length - 1 : index_sensor_name;

      const maxIndex = curve.y.indexOf(Math.max(...curve.y));
      const maxValue = curve.y[maxIndex];
      const maxDate = curve.x[maxIndex];

      const minIndex = curve.y.indexOf(Math.min(...curve.y));
      const minValue = curve.y[minIndex];
      const minDate = curve.x[minIndex];

      if (index_prefix < 0) {
        values_max.push(new Array(sensors_names.length).fill(null));
        dates_max.push(new Array(sensors_names.length).fill(null));
        values_min.push(new Array(sensors_names.length).fill(null));
        dates_min.push(new Array(sensors_names.length).fill(null));

        values_max[values_max.length - 1][index_sensor_name] = maxValue;
        dates_max[dates_max.length - 1][index_sensor_name] = maxDate;
        values_min[values_min.length - 1][index_sensor_name] = minValue;
        dates_min[dates_min.length - 1][index_sensor_name] = minDate;

        headers_values.push(curve.prefix || curve.position_in_sensor);
        headers_unit.push(curve.engineering_unit);
      } else if (index_prefix > -1) {
        values_max[index_prefix][index_sensor_name] = maxValue;
        dates_max[index_prefix][index_sensor_name] = maxDate;
        values_min[index_prefix][index_sensor_name] = minValue;
        dates_min[index_prefix][index_sensor_name] = minDate;
      } else {
        values_max[index_position_in_sensor][index_sensor_name] = maxValue;
        dates_max[index_position_in_sensor][index_sensor_name] = maxDate;
        values_min[index_position_in_sensor][index_sensor_name] = minValue;
        dates_min[index_position_in_sensor][index_sensor_name] = minDate;
      }
    }

    const entetes = [[checkMot('nom')]];
    headers_values.forEach((valeur, index) => {
      entetes.push([`${checkMot('max')} ${valeur} [${checkMot('date')}]`]);
      entetes.push([`${checkMot('max')} ${valeur} [${headers_unit[index]}]`]);
    });

    headers_values.forEach((valeur, index) => {
      entetes.push([`${checkMot('min')} ${valeur} [${checkMot('date')}]`]);
      entetes.push([`${checkMot('min')} ${valeur} [${headers_unit[index]}]`]);
    });

    const cells_values = [];
    dates_max.forEach((dates, index) => {
      cells_values.push(convertiUtsToDate(dates));
      cells_values.push(values_max[index]);
    });

    dates_min.forEach((dates, index) => {
      cells_values.push(convertiUtsToDate(dates));
      cells_values.push(values_min[index]);
    });

    const headerColor = '#EFB805';
    const data = [
      {
        type: 'table',
        columnwidth: [8, 3, 3, 3, 3, 3, 3],
        header: {
          values: entetes,
          align: ['left', 'center'],
          line: { width: 1, color: '#000000' },
          fill: { color: headerColor },
          font: { family: 'Arial', size: 17, color: 'white' },
        },
        cells: {
          values: [sensors_names, ...cells_values],
          align: ['left', 'center'],
          line: { color: '#000000' },
          font: { family: 'Arial', size: 17, color: ['#506784'] },
          height: 25,
        },
      },
    ];

    return { data, layout };
  }, [configuration, donnees, viewobj_json_content]);

  return (
    <BibliothequePlotly
      data={tableData.data}
      layout={{
        ...tableData.layout,
        responsive: true,
        ...viewobj_json_content,
      }}
      donneesGraphe={donneesGraphe}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
    />
  );
};

export default TableauMinMaxDate;
